import * as React from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/rivermax/h5/');
const App: React.FunctionComponent = () => {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('rivermaxportablepowerstation');

    const web1Map = {
        us: ['RIVERMAX_M2.webp', 'RIVERMAX_M2.png'],
        au: ['RIVERMAX_M2_au.webp', 'RIVERMAX_M2_au.png'],
        uk: ['RIVERMAX_M2_uk.webp', 'RIVERMAX_M2_uk.png'],
        de: ['RIVERMAX_M2_eu.webp', 'RIVERMAX_M2_eu.png'],
        fr: ['RIVERMAX_M2_eu.webp', 'RIVERMAX_M2_eu.png'],
        eu: ['RIVERMAX_M2_eu.webp', 'RIVERMAX_M2_eu.png'],
        it: ['RIVERMAX_M2_eu.webp', 'RIVERMAX_M2_eu.png'],
        es: ['RIVERMAX_M2_eu.webp', 'RIVERMAX_M2_eu.png'],
        cn: ['RIVERMAX_M2_cn.webp', 'RIVERMAX_M2_cn.png'],
        za: ['RIVERMAX_M2_za.webp', 'RIVERMAX_M2_za.png'],
        sa: ['RIVERMAX_M2_uk.webp', 'RIVERMAX_M2_uk.png'],
    };

    return (
        <>
            <section className={`river-mini-overview ${css.OverView}`}>
                <article className="grid-content">
                    <div className="view-item view-item-1">
                        <EFPic name={['RIVERMAX_M1.webp', 'RIVERMAX_M1.png']} alt={t('river_max.image.Capacity')} aria-label={t('river_max.image.Capacity')} />
                        <span className="text">{t('river_max.image.Capacity')}</span>
                    </div>
                    <div className="view-item view-item-2">
                        <EFPic name={['RIVERMAX_M3.webp', 'RIVERMAX_M3.png']} alt={t('river_max.image.600Wh')} aria-label={t('river_max.image.600Wh')} />
                        <span className="text">{t('river_max.image.AC Output')}</span>
                        <span className="text">{t('river_max.image.600Wh')}</span>
                    </div>
                    <div className="view-item view-item-3">
                        <EFPic name={['RIVERMAX_M4.webp', 'RIVERMAX_M4.png']} alt={t('river_max.image.1800W')} aria-label={t('river_max.image.1800W')} />
                        <span className="text">{t('river_max.image.1800W')}</span>
                    </div>
                    <div className="view-item view-item-4">
                        <EFPic name={['RIVERMAX_M5.webp', 'RIVERMAX_M5.png']} alt={t('river_max.image.Charging')} aria-label={t('river_max.image.Charging')} />
                        <span className="text">{t('river_max.image.Charging')}</span>
                    </div>
                    <div className="view-item view-item-5">
                        <EFPic name={['RIVERMAX_M6.webp', 'RIVERMAX_M6.png']} alt={t('river_max.image.devices')} aria-label={t('river_max.image.devices')} />
                        <span className="text">
                            {t('river_max.image.Power up to')}
                            <br />
                            <span>{t('river_max.image.10 devices')}</span>
                        </span>
                    </div>
                    <div className="view-item view-item-6">
                        <EFPic
                            name={['RIVERMAX_M7.webp', 'RIVERMAX_M7.png']}
                            alt={t('river_max.image.App Controls')}
                            aria-label={t('river_max.image.App Controls')}
                        />
                        <span className="text">{t.raw('river_max.image.App Controls')}</span>
                    </div>
                    <div className="view-item view-item-7">
                        <EFPic
                            name={web1Map[locale as keyof typeof web1Map] || web1Map['us']}
                            alt={t('river_max.image.Detachable')}
                            aria-label={t('river_max.image.Detachable')}
                        />
                        <span className="text">
                            {t('river_max.image.Detachable')}
                            <br />
                            {t('river_max.image.Design')}
                        </span>
                    </div>
                </article>
            </section>
        </>
    );
};

export default App;
